// @flow
import { createAction } from 'redux-action';

export const SET_QUERY = 'marketplace/search/set-query';

export const setQuery = createAction(SET_QUERY);
